import Vue from 'vue'
import Router from 'vue-router'
import {
  LayoutHome,
  LayoutMonitoring,
  LayoutEvents,
  LayoutStatistics,
  LayoutAssets,
  LayoutMaintenance,
  LayoutSystem
} from 'layouts'
import {
  Login,
  // 主页
  SystemSummary,
  StationOverview,
  AlarmCenter,
  // 监控中心
  DeviceMap,
  XdhDeviceMap,
  StationMap, // 该组件采用动态加载方式无法通过编译！！！
  LiveVideo,
  MinLiveVideo,
  VehicleViolatoinDetection,
  BroadcastSystem,
  // EnvironmentMonitoring,
  // PowerMonitoring,
  // SecuritySystem,
  // FireFightingSystem,
  // EquipmentMonitoring,
  InfraredThermography,
  LowVoltageDetection,
  // AuxiliaryControl,
  ParkingManagement,
  // 事件记录
  AlarmEvents,
  BusinessData,
  PersonalAccessRecords,
  VehiclePassRecords,
  LoginLogs,
  OperationLogs,
  SystemLogs,
  // 资产中心
  MonitoringDevice,
  Camera,
  // 统计分析
  CameraArchiveStatistics,
  VideoDiagnosisStatistics,
  // 运维中心
  VideoDiagnosisStatus,
  // 系统管理
  RecordSpace,
  RecordTask,
  RecordRecord,
  CaptureTask,
  CaptureRecord,
  Page404
} from 'views'

// 延迟加载组件
// 由于该方式无法再dev模式下正常编译，临时屏蔽
// // 布局
// const LayoutHome = () => import('@/layouts/layoutHome')
// const LayoutMonitoring = () => import('@/layouts/layoutMonitoring')
// const LayoutEvents = () => import('@/layouts/layoutEvents')
// const LayoutStatistics = () => import('@/layouts/layoutStatistics')
// const LayoutAssets = () => import('@/layouts/layoutAssets')
// const LayoutMaintenance = () => import('@/layouts/layoutMaintenance')
// const LayoutSystem = () => import('@/layouts/layoutSystem')
// const Login = () => import('@/views/login')
// // 主页
// const SystemSummary = () => import('@/views/home/systemSummary')
// const StationOverview = () => import('@/views/home/stationOverview')
// const AlarmCenter = () => import('@/views/home/alarmCenter')
// // 监控中心
// const DeviceMap = () => import('@/views/monitoring/deviceMap')
// const XdhDeviceMap = () => import('@/views/monitoring/xdhDeviceMap')
// const StationMap = () => import('@/views/monitoring/stationMap')
// const LiveVideo = () => import('@/views/monitoring/liveVideo')
// const MinLiveVideo = () => import('@/views/monitoring/minLiveVideo')
// const VehicleViolatoinDetection = () => import('@/views/monitoring/vehicleViolatoinDetection')
// const BroadcastSystem = () => import('@/views/monitoring/broadcastSystem')
const EnvironmentMonitoring = () => import('@/views/monitoring/environmentMonitoring')
const PowerMonitoring = () => import('@/views/monitoring/powerMonitoring')
const SecuritySystem = () => import('@/views/monitoring/securitySystem')
const FireFightingSystem = () => import('@/views/monitoring/fireFightingSystem')
const EquipmentMonitoring = () => import('@/views/monitoring/equipmentMonitoring')
// const InfraredThermography = () => import('@/views/monitoring/infraredThermography')
// const LowVoltageDetection = () => import('@/views/monitoring/lowVoltageDetection')
const AuxiliaryControl = () => import('@/views/monitoring/auxiliaryControl')
// const ParkingManagement = () => import('@/views/monitoring/parkingManagement')
// // 事件记录
// const AlarmEvents = () => import('@/views/events/alarmEvents')
// const BusinessData = () => import('@/views/events/businessData')
// const PersonalAccessRecords = () => import('@/views/events/personalAccessRecords')
// const VehiclePassRecords = () => import('@/views/events/vehiclePassRecords')
// const LoginLogs = () => import('@/views/events/loginLogs')
// const OperationLogs = () => import('@/views/events/operationLogs')
// const SystemLogs = () => import('@/views/events/systemLogs')
// // 资产中心
// const MonitoringDevice = () => import('@/views/assets/monitoringDevice')
// const Camera = () => import('@/views/assets/camera')
// // 统计分析
// const CameraArchiveStatistics = () => import('@/views/statistics/cameraArchiveStatistics')
// const VideoDiagnosisStatistics = () => import('@/views/statistics/videoDiagnosisStatistics')
// // 运维中心
// const VideoDiagnosisStatus = () => import('@/views/maintenance/videoDiagnosisStatus')
// // 系统管理
// const RecordSpace = () => import('@/views/system/recordSpace')
// const RecordTask = () => import('@/views/system/recordTask')
// const RecordRecord = () => import('@/views/system/recordRecord')
// const CaptureTask = () => import('@/views/system/captureTask')
// const CaptureRecord = () => import('@/views/system/captureRecord')
// const Page404 = () => import('@/views/errorPages/page404')

const IFrame = () => import('@/components/iFrame')

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  // 主页
  {
    path: '/home',
    name: 'home',
    component: LayoutHome,
    redirect: '/home/system-summary',
    children: [
      {
        path: 'system-summary',
        name: 'system-summary',
        component: SystemSummary
      },
      {
        path: 'station-overview',
        name: 'station-overview',
        component: StationOverview
      },
      {
        path: 'alarm-center',
        name: 'alarm-center',
        component: AlarmCenter
      }
    ]
  },
  // 监控中心
  {
    path: '/monitoring',
    name: 'monitoring',
    component: LayoutMonitoring,
    redirect: '/monitoring/live-video',
    children: [
      {
        path: 'device-map',
        name: 'device-map',
        component: DeviceMap
      },
      {
        path: 'xdh-device-map',
        name: 'xdh-device-map',
        component: XdhDeviceMap
      },
      {
        path: 'station-map',
        name: 'station-map',
        component: StationMap
      },
      {
        path: 'station-map2',
        name: 'station-map2',
        component: StationMap
      },
      {
        path: 'station-map3',
        name: 'station-map3',
        component: StationMap
      },
      {
        path: 'station-map4',
        name: 'station-map4',
        component: StationMap
      },
      {
        path: 'live-video',
        name: 'live-video',
        component: LiveVideo
      },
      {
        path: 'min-live-video',
        name: 'min-live-video',
        component: MinLiveVideo
      },
      {
        path: 'vehicle-violation-detection',
        name: 'vehicle-violation-detection',
        component: VehicleViolatoinDetection
      },
      {
        path: 'broadcast-system',
        name: 'broadcast-system',
        component: BroadcastSystem
      },
      {
        path: 'environment-monitoring',
        name: 'environment-monitoring',
        component: EnvironmentMonitoring
      },
      {
        path: 'environment-monitoring2',
        name: 'environment-monitoring2',
        component: EnvironmentMonitoring
      },
      {
        path: 'environment-monitoring3',
        name: 'environment-monitoring3',
        component: EnvironmentMonitoring
      },
      {
        path: 'environment-monitoring4',
        name: 'environment-monitoring4',
        component: EnvironmentMonitoring
      },
      {
        path: 'environment-monitoring5',
        name: 'environment-monitoring5',
        component: EnvironmentMonitoring
      },
      {
        path: 'power-monitoring',
        name: 'power-monitoring',
        component: PowerMonitoring
      },
      {
        path: 'equipment-monitoring',
        name: 'equipment-monitoring',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring2',
        name: 'equipment-monitoring2',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring3',
        name: 'equipment-monitoring3',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring4',
        name: 'equipment-monitoring4',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring5',
        name: 'equipment-monitoring5',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring6',
        name: 'equipment-monitoring6',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring7',
        name: 'equipment-monitoring7',
        component: EquipmentMonitoring
      },
      {
        path: 'equipment-monitoring8',
        name: 'equipment-monitoring8',
        component: EquipmentMonitoring
      },
      {
        path: 'infrared-thermography',
        name: 'infrared-thermography',
        component: InfraredThermography
      },
      {
        path: 'low-voltage-detection',
        name: 'low-voltage-detection',
        component: LowVoltageDetection
      },
      {
        path: 'fire-fighting-system',
        name: 'fire-fighting-system',
        component: FireFightingSystem
      },
      {
        path: 'security-system',
        name: 'security-system',
        component: SecuritySystem
      },
      {
        path: 'auxiliary-control',
        name: 'auxiliary-control',
        component: AuxiliaryControl
      },
      {
        path: 'parking-management',
        name: 'parking-management',
        component: ParkingManagement
      },
      {
        path: 'monitoring-iframe1',
        name: 'monitoring-iframe1',
        component: IFrame
      },
      {
        path: 'monitoring-iframe2',
        name: 'monitoring-iframe2',
        component: IFrame
      },
      {
        path: 'monitoring-iframe3',
        name: 'monitoring-iframe3',
        component: IFrame
      },
      {
        path: 'monitoring-iframe4',
        name: 'monitoring-iframe4',
        component: IFrame
      }
    ]
  },
  // 事件记录
  {
    path: '/events',
    name: 'events',
    component: LayoutEvents,
    redirect: '/events/alarm-events',
    children: [
      {
        path: 'alarm-events',
        name: 'alarm-events',
        component: AlarmEvents
      },
      {
        path: 'business-data',
        name: 'business-data',
        component: BusinessData
      },
      {
        path: 'personal-access-records',
        name: 'personal-access-records',
        component: PersonalAccessRecords
      },
      {
        path: 'vehicle-pass-records',
        name: 'vehicle-pass-records',
        component: VehiclePassRecords
      },
      {
        path: 'login-logs',
        name: 'login-logs',
        component: LoginLogs
      },
      {
        path: 'operation-logs',
        name: 'operation-logs',
        component: OperationLogs
      },
      {
        path: 'system-logs',
        name: 'system-logs',
        component: SystemLogs
      }
    ]
  },
  // 统计分析
  {
    path: '/statistics',
    name: 'statistics',
    component: LayoutStatistics,
    redirect: '/statistics/camera-archive-statistics2',
    children: [
      {
        path: 'camera-archive-statistics2',
        name: 'camera-archive-statistics2',
        component: CameraArchiveStatistics
      },
      {
        path: 'video-diagnosis-statistics2',
        name: 'video-diagnosis-statistics2',
        component: VideoDiagnosisStatistics
      }
    ]
  },
  // 资产中心
  {
    path: '/assets',
    name: 'assets',
    component: LayoutAssets,
    redirect: '/assets/camera',
    children: [
      {
        path: 'monitoring-device',
        name: 'monitoring-device',
        component: MonitoringDevice
      },
      {
        path: 'camera',
        name: 'camera',
        component: Camera
      },
      {
        path: 'camera-archive-statistics',
        name: 'camera-archive-statistics',
        component: CameraArchiveStatistics
      }
    ]
  },
  // 运维中心
  {
    path: '/maintenance',
    name: 'maintenance',
    component: LayoutMaintenance,
    redirect: '/maintenance/video-diagnosis-status',
    children: [
      {
        path: 'video-diagnosis-status',
        name: 'video-diagnosis-status',
        component: VideoDiagnosisStatus
      },
      {
        path: 'video-diagnosis-statistics',
        name: 'video-diagnosis-statistics',
        component: VideoDiagnosisStatistics
      }
    ]
  },
  // 系统管理
  {
    path: '/system',
    name: 'system',
    component: LayoutSystem,
    redirect: '/system/record-space',
    children: [
      {
        path: 'record-space',
        name: 'record-space',
        component: RecordSpace
      },
      {
        path: 'record-task',
        name: 'record-task',
        component: RecordTask
      },
      {
        path: 'record-record',
        name: 'record-record',
        component: RecordRecord
      },
      {
        path: 'capture-task',
        name: 'capture-task',
        component: CaptureTask
      },
      {
        path: 'capture-record',
        name: 'capture-record',
        component: CaptureRecord
      }
    ]
  },
  {
    path: '*',
    name: 'page404',
    component: Page404
  }
]

export default new Router({
  mode: 'hash',
  linkActiveClass: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js